import React from "react";
import { Helmet } from "react-helmet-async";

const Treatments: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Le Pratiche | Riama</title>
        <meta property="og:type" content="website" />
        <meta name="description" content="Scopri trattamenti olistici come il Metodo TRE®, lo Zen Shiatsu e il Massaggio Thailandese. Pratiche che armonizzano corpo, mente e spirito e aiutano a liberare tensioni fisiche ed emotive." />
        <meta property="og:site_name" content="Le pratiche: Metodo TRE®, Zen Shiatsu e Massaggio Thailandese" />
        <meta property="og:url" content="https://riamaolistica.it/" />
        <meta property="og:title" content="Le pratiche: Metodo TRE®, Zen Shiatsu e Massaggio Thailandese" />
        <meta property="og:description" content="Scopri trattamenti olistici che armonizzano corpo, mente e spirito attraverso tecniche naturali per riequilibrare il sistema nervoso e il flusso energetico." />
        <meta property="og:image:jpg" content="https://riamaolistica.it/tre.webp" />
      </Helmet>

      <section className="treatments bg-riama-white py-16">
        <div className="container mx-auto px-4">
          {/* Titolo principale */}
          <h1 className="text-4xl font-bold text-riama-blue text-center mb-12">
            TIPOLOGIE DI TRATTAMENTI
          </h1>

          {/* Metodo TRE */}
          <div className="mb-16">
            <h1 className="text-4xl font-bold text-center text-riama-red mb-4">
              PERCORSO DI RIEQUILIBRIO DEL SISTEMA NERVOSO
            </h1>
            <h2 className="text-2xl font-bold text-center text-riama-orange">
              Come rilasciare tensioni fisiche ed emotive accumulate nel corpo
            </h2>
            <h2 className="text-2xl text-center text-riama-orange mb-8" style={{ fontWeight: 500 }}>
              Metodo TRE®
            </h2>

            <p className="text-lg text-riama-blue mb-6">
              Durante il percorso di riequilibrio del sistema nervoso impariamo insieme come attivare nel corpo un <strong>movimento vibratorio</strong> (tremore neurogeno) totalmente spontaneo e indolore, per rilasciare <strong>tensioni e traumi</strong> accumulati nel tempo in zone e muscoli specifici del corpo.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Questo rilascio è essenziale per ristabilire equilibrio nel sistema nervoso autonomo e conseguentemente ritrovare uno stato di benessere e migliore comunicazione tra le varie parti che compongono l’essere umano - fisiche, comportamentali ed emotive - rendendo la nostra <strong>vita più piena e libera</strong>.
            </p>

            <h3 className="text-xl font-bold text-riama-orange mb-4">
              Perché è importante che questo rilascio avvenga?
            </h3>

            <p className="text-lg text-riama-blue mb-6">
              Il corpo ha una sua memoria alla quale non sempre ci è permesso accedervi. In caso di un <strong>vissuto non risolto</strong>, il corpo metterà in atto <strong>strategie di sopravvivenza</strong> affinché ci sia possibile continuare a fare esperienza della nostra vita, seppure in uno stato di <strong>sregolazione</strong>.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Spesso ciò vuol dire non rendersi conto di procedere con il pilota automatico, ignari dei meccanismi di protezione che attuiamo a causa di un vissuto che non è stato correttamente integrato ed espletato. Il corpo continuerà così a sentirsi minacciato, rimanendo in uno stato di allerta continua.
            </p>
            <p className="text-lg text-riama-blue">
              Per ognuno di noi questo assumerà risposte diverse che potrebbero tradursi come:
            </p>
            <ul className="list-disc pl-6 text-lg text-riama-blue mb-6">
              <li>stati d’ansia o di panico</li>
              <li>dolori cronici e senza apparente causa</li>
              <li>aggressività</li>
              <li>ipercontrollo</li>
              <li>sonno disturbato</li>
              <li>passività, sensazione di blocco</li>
              <li>sensazioni di sopraffazione</li>
              <li>scarsa energia, lucidità e curiosità verso la vita</li>
              <li>depressione</li>
            </ul>

            <h3 className="text-xl font-bold text-riama-orange mb-4">
              Come si svolge nella pratica?
            </h3>

            <p className="text-lg text-riama-blue mb-6">
              Eseguiremo insieme <strong>esercizi semplici, gentili ed efficaci</strong>, permettendo al corpo di lasciare andare bagagli inutili - recenti e più datati. Non c’è bisogno di niente se non del proprio corpo e di un tappetino.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Già dalla prima sessione sarà possibile trovare maggiore leggerezza mentale e fisica, rilassatezza, radicamento, lucidità e risposte più armoniose.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              La mia guida sarà costante durante tutta la durata della sessione, accertandomi che ognuno viva il più possibile un’<strong>esperienza piacevole e trasformativa</strong>.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Il primo incontro è sempre preceduto da una <strong>chiamata conoscitiva gratuita</strong>, oltre a rimanere disponibile per eventuali domande nei giorni che intercorrono tra una sessione e un’altra.
            </p>
            <p className="text-lg text-riama-blue mb-6">
              È possibile partecipare sia a <strong>incontri di gruppo che individuali.</strong>
            </p>


            <div className="text-center mb-8">
              <a href="https://calendly.com/riama-olistica/chiamata-conoscitiva" className="text-riama-red font-bold underline">
                Clicca qui per prenotare la tua chiamata conoscitiva
              </a>
              <br />
              <br />
              <a href="https://www.instagram.com/riama_shiatsu/" className="text-riama-red font-bold underline">
                Rimani aggiornata/o sui prossimi incontri seguendomi su Instagram
              </a>
            </div>

            <h3 className="text-xl font-bold text-riama-orange mb-4">
              Perché è importante affidarsi a una guida?
            </h3>

            <p className="text-lg text-riama-blue mb-6">
              In un mondo in cui abbiamo perso la connessione con il nostro corpo, anche a seguito del condizionamento causato dall’educazione ricevuta, abbiamo contemporaneamente dato sempre più importanza al fare da soli. Tendenza che è stata ulteriormente alimentata dagli schermi sempre più presenti nelle nostre giornate.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Fortunatamente, però, la <strong>conoscenza del proprio corpo</strong> sta tornando ad essere essenziale affinché possiamo essere nuovamente autori attivi e protagonisti della nostra vita.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Oltre a ciò, credo fortemente nell’importanza di tornare alla <strong>condivisione</strong> e al <strong>lavoro in presenza</strong> con altri, che sia il supporto di una singola persona o ancora di più di un gruppo.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Seppure inizialmente questo metodo sia nato come strumento da usare in autonomia, si è poi potuto osservare come la presenza di un operatore renda il processo nettamente più funzionale e fluido. 
              <br />
              <br />
              Vuol dire avere uno sguardo esterno che con accoglienza e rispetto asseconda e accompagna la naturale e personale risposta che ogni corpo ha.
            </p>

            <h3 className="text-xl font-bold text-riama-orange mb-4">
              Questo metodo si può praticare in concomitanza ad altre terapie?
            </h3>

            <p className="text-lg text-riama-blue mb-6">
              Assolutamente sì! 
              <br />
              Si sposa benissimo con qualsiasi terapia, rendendo il proprio <strong>percorso più completo</strong> e <strong>accelerandone i risultati.</strong> 
              <br />
              <br />
              Ci affidiamo troppo spesso a terapie prettamente cognitive, che lasciano spazio alla parola e alla comprensione dei nostri meccanismi solo a livello mentale. 
              <br />
              <br />
              Sebbene queste siano importanti, non dimentichiamo di avere un corpo.
            </p>

            <p className="text-lg text-riama-blue mb-6">
              Fu l’uomo a creare divisione tra mente e corpo. 
              <br />Ma nessuna persona vivente conosce tale separazione.
            </p>

            <div className="text-center mb-8">
              <a href="https://calendly.com/riama-olistica/chiamata-conoscitiva" className="text-riama-red font-bold underline">
                Clicca qui per prenotare la tua chiamata conoscitiva
              </a>
              <br />
              <br />
              <a href="https://www.instagram.com/riama_shiatsu/" className="text-riama-red font-bold underline">
                Rimani aggiornata/o sui prossimi incontri seguendomi su Instagram
              </a>
            </div>

            <p className="text-lg text-riama-orange font-bold mb-2">
              Durata sessione: 1 ora e 30 minuti
            </p>
            <p className="text-lg text-riama-orange font-bold">
              Contributo: 90€
            </p>
          </div>

          {/* Zen Shiatsu */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold text-center text-riama-red mb-2">
              ZEN SHIATSU
            </h2>
            <h2 className="text-xl font-bold text-riama-orange text-center mb-2">
              Metodo Masunaga | Certificato APOS
            </h2>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Il termine <strong>Shiatsu</strong> significa letteralmente <em>pressione con le dita</em>, dove <strong>shi</strong> è dito e <strong>atsu</strong> pressione.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Lo Shiatsu è un trattamento manuale effettuato sulla persona con l’intento di ristabilire un corretto equilibrio psicofisico ed uno stato di benessere prolungato.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Non è previsto l’utilizzo di oli, per cui il ricevente (<strong>uke</strong>, in giapponese) rimane vestito con abiti comodi e la pratica si esegue su di un futon (materasso giapponese adagiato sul pavimento) esercitando pressioni continue sul corpo attraverso palmi, pollici, gomiti e ginocchia, oltre a stiramenti e rotazioni degli arti.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Le pressioni dell’operatore (<strong>tori</strong>) agiscono direttamente sui meridiani, che altro non sono che i canali lungo i quali scorre l’energia vitale del corpo (<strong>Qi</strong>) che, in questo modo, viene aiutata nel ritrovare il suo libero fluire, ristabilendo un maggiore benessere ed una migliore risposta di autoguarigione nel corpo.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Lo Shiatsu guarda alla persona nella sua totalità - struttura energetica, fisica e psichica - andando alla ricerca della causa del suo malessere.
            </p>
            <ul className="list-disc pl-6 mb-4 text-lg text-riama-blue">
              <li>Riduzione di stress e ansia</li>
              <li>Riacquisizione di un sonno senza interruzioni e più profondo</li>
              <li>Riduzione dei dolori da ciclo mestruale e maggiore regolarità</li>
              <li>Rilascio di tensioni muscolari</li>
              <li>Rafforzamento/stimolazione del sistema immunitario</li>
              <li>Maggiore mobilità nelle articolazioni</li>
              <li>Maggiore regolarità intestinale</li>
              <li>Migliore circolazione sanguigna e linfatica</li>
              <li>Migliore ascolto del proprio corpo</li>
              <li>Ripristino di uno stato di rilassamento profondo e duraturo volto all’ottimizzazione del funzionamento del corpo</li>
            </ul>
            <p className="text-lg text-riama-orange mb-4">
              Durata trattamento: <strong>45 minuti</strong>
            </p>
            <p className="text-lg text-riama-orange mb-4">
              Contributo: <strong>55€</strong>
            </p>
          </div>

          {/* Dynamic Thai Massage */}
          <div>
            <h2 className="text-3xl font-bold text-center text-riama-red mb-2">
              DYNAMIC THAI MASSAGE
            </h2>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Il Massaggio Dinamico Thailandese è una meditazione in movimento, una danza effettuata su tutti i liquidi che compongono il nostro corpo e quindi sull’elemento acqua.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Si svolge su di un futon adagiato sul pavimento e prevede l’utilizzo di tecniche oscillatorie, vibrazioni, così come mobilitazioni delle articolazioni e stiramenti. Tutte queste tecniche hanno a che fare con il ritmo.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Il ritmo è un ottimo strumento per invitare il ricevente a lasciarsi andare totalmente ad un movimento passivo e alla gravità.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Ogni individuo ha il suo personale ritmo interno e non rispettarlo porta ad uno stato di esaurimento e presenza di vari disturbi. Vivere invece nel rispetto di quest’ultimo permette alla nostra evoluzione di raggiungere il suo massimo potenziale.
            </p>
            <p className="text-lg font-medium text-riama-blue mb-4">
              Queste tecniche aiutano proprio ad entrare in risonanza con il nostro ritmo naturale.
            </p>
            <ul className="list-disc pl-6 mb-4 text-lg text-riama-blue">
              <li>Ritrovare mobilità e libertà nel sistema muscolo scheletrico e nelle articolazioni</li>
              <li>Migliorare la circolazione di tutti i fluidi (sangue e sistema linfatico)</li>
              <li>Supportare la digestione (peristalsi)</li>
              <li>Ristabilire un libero fluire di energia</li>
              <li>Bilanciare il sistema nervoso</li>
              <li>Ristabilire il ritmo perso e di conseguenza riconnettersi al proprio ritmo interiore</li>
            </ul>
            <p className="text-lg text-riama-blue mb-4">Al contrario, è sconsigliato per chi:</p>
            <ul className="list-disc pl-6 mb-4 text-lg text-riama-blue">
              <li>Presenta capogiri, nausea</li>
              <li>Si è recentemente infortunato (aspettare almeno 2 settimane)</li>
              <li>È affetto da trombosi</li>
            </ul>
            <p className="text-lg text-riama-orange mb-4">
              Durata trattamento: <strong>90 minuti</strong>
            </p>
            <p className="text-lg text-riama-orange mb-4">
              Contributo: <strong>75€</strong>
            </p>
            <p className="text-sm text-riama-red italic">
              * I trattamenti non sono da ritenersi come alternativi ad una terapia allopatica/medica/psicologica.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Treatments;
